<template>
  <v-container class="primary" fluid style="height: 100vh">
    <v-form v-model="formValido" ref="formularioLogin">
      <v-row class="d-flex align-center justify-center">
        <v-col cols="12" class="justify-center mt-8">
          <v-img src="@/assets/sideop-png.png" height="80" contain> </v-img>
        </v-col>
        <v-col cols="12" md="4">
          <v-row>
            <v-col cols="12" class="text-center d-flex align-center justify-center pb-0 mt-8">
              <b class="white--text">Inicia sesión con tu cuenta</b>
            </v-col>
            <v-col cols="12" v-if="errorLogin">
              <v-alert type="warning" v-if="errorLogin">
                {{ errorLogin }}
              </v-alert>
            </v-col>
            <custom-text-field-secondary
              cols="12"
              v-model="login.correoElectronico"
              label="Correo electronico"
              type="email"
              :rules="[mixReglas.requerido, mixReglas.email]"
              @keyup.enter="doLogin"
            >
            </custom-text-field-secondary>
            <custom-text-field-secondary
              cols="12"
              v-model="login.password"
              prepend-inner-icon="mdi-key-variant"
              label="Contraseña"
              :append-icon="mostrarPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="mostrarPassword ? 'text' : 'password'"
              :rules="[mixReglas.requerido]"
              @click:append="mostrarPassword = !mostrarPassword"
              @keyup.enter="doLogin"
            >
            </custom-text-field-secondary>
            <v-col cols="12" class="my-5">
              <v-btn
                block
                dark
                class="rounded-lg"
                large
                @click.prevent="doLogin"
                :disabled="enviando"
                :loading="enviando"
                color="base1"
              >
                Iniciar sesión
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import HACER_LOGIN from "@/graphql/mutations/auth/hacerLogin.gql";
import CustomTextFieldSecondary from "@/components/inputs/TextFieldSecondary.vue";

export default {
  name: "login",
  components: {
    CustomTextFieldSecondary,
  },
  data() {
    return {
      formValido: false,
      enviando: false,
      mostrarPassword: false,
      errorLogin: "",
      login: {
        correoElectronico: null,
        password: null,
      },
      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.login = {
        correoElectronico: null,
        password: null,
      };
      this.errorLogin = "";
      this.$refs.formularioLogin.reset();
    },
    formattedUser(user) {
      return {
        id: user.id,
        correoElectronico: user.correoElectronico,
        nombre: user.funcionario ? user.funcionario.nombre : user.contratista.nombreRazonSocial,
        puesto: user.puesto || null,
        esSupervisor: user.funcionario?.esSupervisor || false,
        avatarPublicKey: user.avatarPublicKey,
        roles: user.roles,
        scopes: user.scopes,
      };
    },
    async doLogin() {
      this.enviando = true;
      const { login } = this;
      const { correoElectronico, password } = login;
      if (!correoElectronico || !password) {
        this.errorLogin = "Verifique los campos.";
        this.enviando = false;
        return;
      }
      await this.$apollo
        .mutate({
          mutation: HACER_LOGIN,
          variables: { login },
        })
        .then(({ data: { hacerLogin } }) => {
          this.errorLogin = "";
          if (!hacerLogin) return;
          // contratistas
          const { status, token, usuario: datosUsuarios } = hacerLogin;

          if (!status || datosUsuarios.roles.length === 0) {
            return;
          }

          // set localstorage
          localStorage.setItem(process.env.VUE_APP_AUTH_TOKEN || "sideop-app-demo-token", token);

          // set isAuthenticated
          this.$auth.isAuthenticated = status;

          this.$auth.user = this.formattedUser(datosUsuarios);

          this.limpiarFormulario();

          // redirect routes
          if (datosUsuarios.roles.includes("CONTRATISTA:SUPERVISION")) {
            this.$router.push({ name: "contratistas" });
          } else {
            this.$router.push({ name: "administracion" });
          }
        })
        .catch((error) => {
          // eslint-disable-next-line prefer-destructuring
          this.errorLogin = error.message.split(":")[1];
        });
      this.enviando = false;
    },
  },
};
</script>

<style lang="scss"></style>
